import BaseLineSeries from "./private/BaseLineSeries.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function LineSeries(props) {
  return /*#__PURE__*/_jsx(BaseLineSeries, {
    ...props
  });
}